import { useMemo, useRef } from 'react';
import { withLanguageContext } from '@/context';

//* Styles
import TextAnimationStyle from './style';

const TextAnimation = ({ type = 'word', text, translate, delay = 0.15 }) => {
	const refsStyle = useRef(null);
	text = translate(text);

	const inner = useMemo(() => {
		const renderText = () => {
			if (type === 'word') {
				return text.split(' ').map((word, index) => (
					<div
						className='wrapper-word'
						style={{ '--itemDelay': `${Math.floor(index * 10 * delay) / 10}s` }}
						key={index}>
						<span>
							{word}
							{index < text.split(' ').length - 1 && ' '}
						</span>
					</div>
				));
			} else if (type === 'line') {
				return text.split('\n').map((line, index) => <div key={index}>{line}</div>);
			}
			return null;
		};
		return renderText();
	}, []);

	return <TextAnimationStyle ref={refsStyle}>{inner}</TextAnimationStyle>;
};

export default withLanguageContext(TextAnimation, ['translate']);
